import getOAuth2RefreshTokenInfoOperation from 'owa-service/lib/operation/getOAuth2RefreshTokenInfoOperation';
import GetOAuth2RefreshTokenResquest from 'owa-service/lib/contract/GetOAuth2RefreshTokenRequest';
import GetOAuth2RefreshTokenResponse from 'owa-service/lib/contract/GetOAuth2RefreshTokenResponse';
import OAuthProvider from 'owa-service/lib/contract/OAuthProvider';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function getRefreshToken(
    authorizationCode: string
): Promise<GetOAuth2RefreshTokenResponse> {
    const uri: string = `${window.location.protocol}//${
        window.location.hostname
    }/mail/GetAuthorizationCode.html`;

    let request: GetOAuth2RefreshTokenResquest = {
        Header: getJsonRequestHeader(),
        OAuthProvider: OAuthProvider.Google,
        RedirectUri: uri,
        AuthorizationCode: authorizationCode,
    };

    let response = await getOAuth2RefreshTokenInfoOperation(request);
    return response;
}
